import { useLazyQuery } from "@apollo/client";

import shouldPollHelper from "./shouldPoll";
import { UsePolledLazyQuery } from "./types";
import usePollingInterval from "./usePollingInterval";
import usePollingManagement from "./usePollingManagement";

const usePolledLazyQuery: UsePolledLazyQuery = (query, options) => {
  const {
    pollInterval: overridePollInterval,
    pollingGroup,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    shouldPoll, // not needed in useLazyQuery
    ...restOptions
  } = options;
  const queryResult = useLazyQuery(query, restOptions);

  const pollInterval = usePollingInterval(query, pollingGroup, overridePollInterval);

  const [, result] = queryResult;

  /* Disable polling management until the lazy query is executed.
   * Calling refetch/startPolling/stopPolling on an unexecuted lazy query
   * triggers Apollo to fire a request with empty variables.
   */
  const isPollingManagementDisabled = !result.called;

  usePollingManagement(
    pollInterval,
    result.startPolling,
    result.stopPolling,
    shouldPollHelper(options, result),
    result.refetch,
    isPollingManagementDisabled
  );

  return queryResult;
};

export default usePolledLazyQuery;
